import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { AuthGuard } from '@/auth/guard';
import SettingLayout from '@/layouts/setting';
import { LoadingScreen } from '@/components/feedback/loading-screen';
import AdminGuard from '@/auth/guard/admin-guard';
import { generalRoutes } from './general';
import { accountRoutes } from './accounts';
import { approvalFlowRoutes } from './approval-flow';
import { portfolioRoutes } from './portfolio';
import { catalogSectionsRoutes } from './catalog-sections';
import { financesRoutes } from './finances';
import { accessRoutes } from './access';
import { integrationsRoutes } from './integrations';
import { directoryRoutes } from './directory';

export const settingRoutes = [
  {
    path: 'settings',
    element: (
      <AuthGuard>
        <SettingLayout>
          <AdminGuard hasContent>
            <Suspense fallback={<LoadingScreen />}>
              <Outlet />
            </Suspense>
          </AdminGuard>
        </SettingLayout>
      </AuthGuard>
    ),
    children: [
      ...generalRoutes,
      ...accountRoutes,
      ...approvalFlowRoutes,
      ...portfolioRoutes,
      ...catalogSectionsRoutes,
      ...financesRoutes,
      ...accessRoutes,
      ...integrationsRoutes,
      ...directoryRoutes,
    ],
  },
];
